export default "__VITE_ASSET__Btv_Vkni__"